import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip, TooltipProps } from "antd";
import { FC } from "react";

type Props = {
  icon?: React.ReactNode;
  label?: React.ReactNode;
  className?: string;
  iconClassName?: string;
  tooltip?: boolean;
  tooltipProps?: TooltipProps;
};

export const HelpText: FC<Props> = ({
  className = "fs-12",
  icon = <InfoCircleOutlined />,
  label,
  iconClassName = "color-primary",
  tooltip,
  tooltipProps,
}) => {
  if (tooltip === true)
    return (
      <Tooltip title={label} {...tooltipProps}>
        <span className={className}>
          <span className={iconClassName}>{icon}</span>
        </span>
      </Tooltip>
    );

  return (
    <span className={className}>
      {icon && <span className={iconClassName}>{icon}&nbsp;</span>}
      {label}
    </span>
  );
};
